module.exports = __webpack_public_path__ + "static/media/craftsman-logo.39a3916f.png";